import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { useLanguage } from '../../context/language.context';

type Props = {
	onNextMonthClick: () => void;
	onPrevMonthClick: () => void;
	onResetMonthClick: () => void;
	month: number;
	year: number;
};
const MonthSelectionBox = (props: Props) => {
	const { t } = useLanguage();
	return (
		<Box width='max-content' display='flex' alignSelf={'flex-end'} flexDirection={'column'} alignItems={'center'}>
			{/* LTR row: prev on the left, next on the right — avoids RTL flex mirror swapping controls */}
			<Stack gap={2} direction='row' alignItems='center' sx={{ direction: 'ltr' }}>
				<IconButton onClick={props.onPrevMonthClick} aria-label={t('previousMonth')}>
					<ChevronLeft />
				</IconButton>
				<Typography component='span'>{`${props.month + 1}/${props.year}`}</Typography>
				<IconButton onClick={props.onNextMonthClick} aria-label={t('nextMonth')}>
					<ChevronRight />
				</IconButton>
			</Stack>
			<div>
				<Button onClick={props.onResetMonthClick}>{t('resetToCurrentMonth')}</Button>
			</div>
		</Box>
	);
};

export default MonthSelectionBox;
